import React from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const DetalleRubro = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre ===  nombre);

  return (
    <div className='container container_detalle_rubro container-mh'>
      <div className='row'>
        <div className='col-12'>
          <div className='rubro_titulo'>
            <h3 className='title'>{rubro.nombre}</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      <div className='row'>
        {
          rubro.formatos.map((formato, index) => {
            const urlXLSX = formato.xlsx_liga ? formato.xlsx_liga: "/Transparencia/xlsx/a69_" + formato.xlsx + "_UPLAPH.xlsx";
            const urlHTML = formato.htm_liga ? formato.htm_liga: "/Transparencia/htm/a69_" + formato.html + "_UPLAPH.htm";
            return (
              <div key={ index } className='col-md-4 col-12 '>
                <div className='rubro_container_detalle'>
                  <div className='detalle_rubro_nombre'>
                    <h5>{ formato.nombre }</h5>
                  </div>
                  <div className='detalle_rubro_enlaces'>
                    <a className='fa fa-file-excel' href={ urlXLSX } target="_blank"> xlsx</a>
                    <a className='fa fa-table' href={ urlHTML } target="_blank"> Ver Tabla</a>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default DetalleRubro;
